import { motion } from "framer-motion";
import { Chapter, FadeUp, MaskedLines, EASE } from "@/components/motion";
import { CTAButton } from "@/components/CTA";
import WordSwap from "@/components/WordSwap";

const CHAIN = ["AVERÍA", "BUSCAR TÉCNICO", "LLAMADAS", "ESPERAS", "DISPONIBILIDAD", "INCERTIDUMBRE", "PÉRDIDA DE TIEMPO"];

export default function Problem() {
  return (
    <section className="relative py-32 lg:py-44" data-testid="section-problema">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-7">
          <Chapter num="01" label="EL PROBLEMA" className="mb-12" />
          <h2 className="font-display font-800 uppercase leading-[0.98] tracking-tight text-4xl sm:text-6xl lg:text-7xl text-offwhite">
            <MaskedLines
              mode="view"
              lines={[
                <span key="a">Cuando algo falla,</span>,
                <span key="b">
                  el problema no es solo <span className="font-cormorant normal-case font-medium text-metal">la avería.</span>
                </span>,
              ]}
            />
          </h2>
          <FadeUp delay={0.2} className="mt-10 max-w-xl text-mist leading-relaxed">
            Se rompe el aire acondicionado en pleno agosto. Una tubería empieza a perder agua un sábado por la
            mañana. Y de repente, tu jornada ya no va de tu negocio: va de encontrar a alguien que lo arregle.
          </FadeUp>
        </div>

        <div className="lg:col-span-5">
          <div className="border-l border-silver/10 pl-8 space-y-1">
            {CHAIN.map((step, i) => (
              <motion.div
                key={step}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ duration: 0.7, delay: i * 0.09, ease: EASE }}
                className="flex items-baseline gap-5 py-3 border-b border-silver/5 group"
              >
                <span className="font-mono text-[10px] text-steel">{String(i + 1).padStart(2, "0")}</span>
                <span
                  className={`font-oswald uppercase tracking-wide text-xl md:text-2xl transition-colors duration-300 ${
                    i === CHAIN.length - 1 ? "text-glow/90" : "text-mist group-hover:text-silver"
                  }`}
                >
                  {step}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1500px] px-6 lg:px-12 mt-32 lg:mt-44">
        <FadeUp y={20}>
          <span className="font-mono text-[11px] tracking-[0.4em] text-glow/80">AHORA, HAY OTRA FORMA.</span>
        </FadeUp>
        <WordSwap />
        <FadeUp delay={0.15} className="max-w-xl text-mist leading-relaxed">
          Mientras el comercio tradicional pierde horas al teléfono, los comercios con Aprea simplemente
          notifican la incidencia y siguen trabajando.
        </FadeUp>
        <FadeUp delay={0.25} className="mt-10">
          <CTAButton testid="problem-cta-alta">PROTEGER MI COMERCIO</CTAButton>
        </FadeUp>
      </div>
    </section>
  );
}
